import React from 'react';

import { Form, Select, Input, Radio } from 'antd';
import { isUUID } from 'validator';
import { MAGIC_WORDS_OPTIONS } from '../../../../constants';
import { DEBOUNCE_DELAY, FORM_FIELDS } from '../../constants';
import { FIELD_DISABLED_BY_SUPPLY_SOURCE, UUID_MAX_LENGTH } from '../constants';
import { StyledFieldsWrapper } from '../styles';

const WHITE_SPACE_CHECK = /\s/;
const SPECIFIC = 'SPECIFIC';

export const ContentParameters = (props) => {
  const { handleChangeField, getOptionsByFieldName, renderOptions, supplySource, entityType } = props;
  return (
    <StyledFieldsWrapper>
      {/*
    * Hidden until the BE part is ready *
    <Form.Item
      label={FORM_FIELDS.SUPPLY_AD_UNIT_NAME.label}
      name={FORM_FIELDS.SUPPLY_AD_UNIT_NAME.name}
    >
      <Input allowClear />
    </Form.Item> */}
      <Form.Item label={FORM_FIELDS.SERIES.label} name={FORM_FIELDS.SERIES.name}>
        <Input
          disabled={!supplySource || FIELD_DISABLED_BY_SUPPLY_SOURCE?.[FORM_FIELDS?.SERIES?.name]?.[supplySource]}
          allowClear
        />
      </Form.Item>
      {/*
     * Hidden until the BE part is ready *
    <Form.Item label={FORM_FIELDS.POD.label} name={FORM_FIELDS.POD.name}>
      <Input allowClear />
    </Form.Item>
     */}
      <Form.Item label={FORM_FIELDS.ALID_ID.label} name={FORM_FIELDS.ALID_ID.name}>
        <Input
          disabled={!supplySource || FIELD_DISABLED_BY_SUPPLY_SOURCE?.[FORM_FIELDS?.ALID_ID?.name]?.[supplySource]}
          allowClear
        />
      </Form.Item>
      {/* Hidden until the BE part is ready *
      <Form.Item label={FORM_FIELDS.ENTITY_ID.label} name={FORM_FIELDS.ENTITY_ID.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.GENRE.label} name={FORM_FIELDS.GENRE.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.RATING.label} name={FORM_FIELDS.RATING.name}>
        <Input allowClear />
      </Form.Item>
       */}
      <Form.Item
        label={FORM_FIELDS.CONTENT_PARTNER.label}
        name={FORM_FIELDS.CONTENT_PARTNER.name}
        rules={[
          {
            validator: (_, value) => {
              return WHITE_SPACE_CHECK.test(value) ? Promise.reject() : Promise.resolve();
            },
            message: `White spaces are not available for the ${FORM_FIELDS.CONTENT_PARTNER.label}!`,
          },
        ]}
      >
        <Input disabled={!supplySource} maxLength={100} showCount={!!supplySource} allowClear />
      </Form.Item>
      {/* Hidden until the BE part is ready *
      <Form.Item
        label={FORM_FIELDS.CONTENT_PARTNER_PARENT_ID.label}
        name={FORM_FIELDS.CONTENT_PARTNER_PARENT_ID.name}
        rules={[
          {
            validator: (_, value) => {
              return WHITE_SPACE_CHECK.test(value) ? Promise.reject() : Promise.resolve();
            },
            message: `White spaces are not available for the ${FORM_FIELDS.CONTENT_PARTNER_PARENT_ID.label}!`,
          },
        ]}
      >
        <Input disabled={!supplySource} maxLength={100} showCount={!!supplySource} allowClear />
      </Form.Item>
      */}
      <Form.Item label={FORM_FIELDS.VDM.label} name={FORM_FIELDS.VDM.name}>
        <Select
          placeholder="Select"
          disabled={!supplySource}
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.VDM.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.VDM.name).map(renderOptions)}
        </Select>
      </Form.Item>
      {/* ===== Hidden until the BE part is ready =====
      <Form.Item label={FORM_FIELDS.ENTITY_TYPE.label} name={FORM_FIELDS.ENTITY_TYPE.name}>
        <Select placeholder="Select" allowClear>
          {entityType.map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.SPORTS_LEAGUE.label} name={FORM_FIELDS.SPORTS_LEAGUE.name}>
        <Input allowClear />
      </Form.Item> */}
      <Form.Item
        label={FORM_FIELDS.SUPPLY_AD_UNIT_ID.label}
        name={FORM_FIELDS.SUPPLY_AD_UNIT_ID.name}
        validateDebounce={DEBOUNCE_DELAY}
        rules={[
          {
            validator: (_, value) => {
              if (value && !isUUID(value)) {
                return Promise.reject();
              }
              return Promise.resolve();
            },
            message: 'UUID is not valid!',
          },
        ]}
      >
        <Input maxLength={UUID_MAX_LENGTH} showCount allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.MAGIC_WORDS_TYPE.label} name={FORM_FIELDS.MAGIC_WORDS_TYPE.name}>
        <Radio.Group
          options={MAGIC_WORDS_OPTIONS.filter(({ value }) => value !== SPECIFIC)}
          disabled={
            !supplySource || FIELD_DISABLED_BY_SUPPLY_SOURCE?.[FORM_FIELDS?.MAGIC_WORDS_TYPE?.name]?.[supplySource]
          }
        />
      </Form.Item>
    </StyledFieldsWrapper>
  );
};
